<template>
  <div style="position: absolute; top: 0px; bottom: 0px; left: 0px; right: 0px; overflow: auto;">
    <div
      v-if="items.length === 0">
      尚未加入任何餐點
    </div>
    <f7-list
      v-else
      media-list
      style="margin: 0px 0px 30px 0px;">
      <f7-list-item
        v-for="(item, index) in items"
        :key="`favorites-list-${index}`"
        :title="`${item.title}`">
        <img
          v-if="item.coverImgUrl"
          :src="ImageUrlBuilder.url64(item.coverImgUrl, storeId)"
          :srcset="`${ImageUrlBuilder.url128(item.coverImgUrl, storeId)} 2x, ${ImageUrlBuilder.url192(item.coverImgUrl, storeId)} 3x`"
          style="width: 64px; float: left;"
          slot="media"
          alt="餐點圖片">
        <img v-else slot="media" src="@/assets/itemDefault.jpg" style="width: 64px; float: left;" alt="餐點圖片" />
        <div
          slot="inner"
          style="margin: 0px 0px; font-size: 14px; color: #888888; padding-bottom: 0px;">
          <div
            v-for="(question, index) in item.allLevelQuestions || []"
            :key="`favorites-question-${index}`"
            v-if="shouldDisplayQuestion(question)">
            <cart-card-content
              :itemObj="item.stateObj"
              :questionId="question.id">
            </cart-card-content>
          </div>
          <div
            v-if="item.stateObj.specialRequests"
            style="color: #888888; width: 100%; display: inline-block;">
            備註: {{ item.stateObj.specialRequests }}
          </div>
          <hr/>
          <span>總價</span>
          <span style="float: right;">${{ item.totalPrice }}</span>
        </div>
        <div slot="root-end" class="root-end-style" :style="{'border-bottom': index === items.length - 1 ? '0px' : '1px solid rgba(0,0,0,.12)'}">
          <f7-button
              :href="`/stores/${storeId}/items/favorites/${item.id}.${item.stateObj.instanceId}/questions`"
              color="gray"
              style="padding: 0px; min-width: 64px; display: inline-block;">
              <font-awesome-icon icon="edit" />
              修改
            </f7-button>
            <f7-button
              color="gray"
              style="padding: 0px; min-width: 64px; display: inline-block;"
              @click.stop="removeItem({ id: item.id, instanceId: item.stateObj.instanceId, itemBucket: 'favorites' })">
              <font-awesome-icon icon="trash" />
              刪除
            </f7-button>
            <f7-button
              color="gray"
              style="padding: 0px; min-width: 64px; display: inline-block;"
              @click="addToCart(item.stateObj)">
              <font-awesome-icon icon="cart-plus" />
              購買
            </f7-button>
        </div>
        <div slot="after">${{ item.price }}</div>
      </f7-list-item>
    </f7-list>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import FavoritesItemCard from './ItemCard'
import CartCardContent from './CartCardContent'

export default {
  name: 'Favorites',
  dependencies: [
    'platformUtils',
    'ImageUrlBuilder',
    'CartElementBuilder'
  ],
  computed: {
    ...mapState(['init']),
    ...mapGetters([
      'storeId',
      'storeName',
      'storeBranch',
      'currentMenu'
    ]),
    items () {
      return this.itemObjs.map(itemObj => this.CartElementBuilder.buildItem(itemObj, this.currentMenu))
    }
  },
  methods: {
    ...mapActions('itemModule', [
      'removeItem',
      'addFavoriteItemToCart'
    ]),
    addToCart (itemObj) {
      this.addFavoriteItemToCart(itemObj)
      this.$f7.notification.create({
        title: this.storeName,
        titleRightText: this.storeBranch,
        subtitle: this.currentMenu.items[itemObj.id].title,
        text: '已加入購物車',
        closeOnClick: true,
        closeButton: true,
        closeTimeout: 2000
      }).open()
    },
    shouldDisplayQuestion: question =>
      question.alwaysDisplay || !question.isValid || (question.hasValue && !question.isValueDefault) || question.totalPrice !== 0
  },
  props: {
    itemObjs: Array
  },
  components: {
    FavoritesItemCard,
    CartCardContent
  }
}
</script>

<style scoped>
  /* 蓋掉 root-end inner 的預設樣式 */
  .root-end-style {
    margin-left: 95px;
    padding-right: 16px;
    padding-bottom: 5px;
    position: relative;
  }

  /* 目的是要蓋掉 slot inner 的 after 分隔線 */
  .root-end-style::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 5px;
    background: white;
    top: -3px;
    left: 0;
    z-index: 50;
    padding-right: -16px;
  }

</style>
